// 射线法: 判断经纬度点是否落在单个环(外环)内
function pointInRing(lng, lat, ring) {
    let inside = false;
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        const xi = ring[i][0];
        const yi = ring[i][1];
        const xj = ring[j][0];
        const yj = ring[j][1];
        const intersect =
            yi > lat !== yj > lat && lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}

// 判断经纬度点是否落在 GeoJSON 面域内(支持 Polygon / MultiPolygon)
export function pointInGeoJson(lng, lat, geoJson) {
    if (!geoJson || !geoJson.features) return false;
    return geoJson.features.some((feature) => {
        const geometry = feature.geometry;
        if (!geometry) return false;
        if (geometry.type === "Polygon") {
            return geometry.coordinates.some((ring) => pointInRing(lng, lat, ring));
        }
        if (geometry.type === "MultiPolygon") {
            return geometry.coordinates.some((polygon) =>
                polygon.some((ring) => pointInRing(lng, lat, ring))
            );
        }
        return false;
    });
}